import { actionTypes } from '../types'

const initState = {
    regs: [],
    questions: []
};

const membershipsReducer = (state = initState, action) => {

    switch (action.type) {

        case actionTypes.GET_MEMBERSHIPS:
            {
                let newState;
                newState = {
                    ...state,
                    regs: action.payload.resp.filter(item => !item.excludeInConsolidatedForm && item.isLive && item.includePayment)
                }
                return newState;
            }

        case actionTypes.GET_QUESTIONS:
            {
                let newState;
                newState = {
                    ...state,
                    questions: action.payload.resp
                }
                return newState;
            }

        default:
            {
                return state
            }

    }

}

export default membershipsReducer
